<p-button
  (click)="onClicked($event)"
  [disabled]="disabled() || isLoading()"
  [icon]="primeIcon()"
  [label]="label()"
  [loading]="this.isLoading()"
  [pTooltip]="tooltip()"
  [severity]="severity()"
  [size]="size()"
  [tooltipPosition]="'top'"
  [variant]="this.variant()"
/>

